export default __webpack_public_path__ + "static/media/travclan.575eddd8.jpg";